import React from 'react';
import SettingsSection from './SettingsSection';
import * as styles from './SettingsSectionUpsell.module.scss';
import { useAppDispatch } from '../app/redux/useAppSelector';
import type { BadgeColor } from '../components/Badge';
import Badge from '../components/Badge';
import Card from '../components/Card';
import { PlanTier } from '../graphql/generated/graphql';
import type { PlanFeatureKey } from '../organization/PricingConfig';
import PricingModalButton from '../organization/PricingModalButton';
import UpgradeBadge from '../organization/UpgradeBadge';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import { openPricingModal } from '../utils/url/pricingPath';

interface SettingsSectionUpsellProps {
  header?: string;
  feature?: PlanFeatureKey;
  description: string;
  contentCards: React.ReactNode;
  minTier?: PlanTier;
}

const getTierBadgeColor = (tier: string): BadgeColor => {
  switch (tier) {
    case PlanTier.Enterprise:
      return 'yellow';
    case PlanTier.Business:
      return 'blue';
    default:
      return 'yellow';
  }
};

const SettingsSectionUpsell = ({
  header,
  feature,
  description,
  contentCards,
  minTier,
}: SettingsSectionUpsellProps) => {
  const isMobile = useIsSize(Sizes.SM);
  const dispatch = useAppDispatch();

  return (
    <SettingsSection
      header={
        header && (
          <div className={styles.header}>
            {header}
            <div className={styles.headerUpgradeButton}>
              {isMobile && minTier ? (
                <Badge color={getTierBadgeColor(minTier)}>{minTier}</Badge>
              ) : (
                <UpgradeBadge
                  onClick={() => {
                    openPricingModal(dispatch, feature);
                  }}
                />
              )}
            </div>
          </div>
        )
      }
    >
      <Card noPadding>
        <div className={styles.contentWrapper}>
          <div className={styles.description}>{description}</div>
          <div className={styles.cardsWrapper}>
            <div className={styles.cards}>{contentCards}</div>
          </div>
          <PricingModalButton feature={feature}>
            View upgrade options
          </PricingModalButton>
        </div>
      </Card>
    </SettingsSection>
  );
};

export default SettingsSectionUpsell;
